import type { AuthorInfo } from "@serophin/nottldr-shared";
import { Share2 } from "lucide-preact";
import { useToast } from "../../contexts/ToastContext";

/** Shares an author's page through the device's share sheet, or copies its link where there is none. */
export const ShareAuthorButton = ({ author }: { author: AuthorInfo }) => {
  const toast = useToast();

  const handleClick = async (event: MouseEvent) => {
    event.preventDefault();
    const url = `${window.location.origin}/authors/${author.alias}`;
    try {
      if (navigator.share) {
        await navigator.share({ url, title: `${author.alias} on !tldr`, text: author.tagline });
      } else {
        await navigator.clipboard.writeText(url);
        toast.success("Link copied to clipboard");
      }
    } catch {
      // The visitor closed the share sheet.
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      class="p-2 rounded-full bg-black/50 hover:bg-black/75 backdrop-blur-sm transition-colors"
      aria-label="Share author profile"
    >
      <Share2 size={16} class="text-white" />
    </button>
  );
};
